import React from 'react';
import { Copy, Label } from '@grubhubprod/gh-cookbook-react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { CorpInvoicingMethod } from 'src/components/enterprise/features/Corporate/components/Form/types/CorporateForm';
import { CookbookRadioWrapper } from 'src/components/CookbookRadioWrapper/CookbookRadioWrapper';

export interface InvoicingMethodControlProps {
  name: string;
  id: string;
  singleOptionSelected: boolean;
  disabledMultiOption: boolean;
  multiDisableReason: string;
}

export function InvoicingMethodControl({
  name,
  id,
  singleOptionSelected,
  disabledMultiOption,
  multiDisableReason,
}: InvoicingMethodControlProps): JSX.Element {
  const { control } = useFormContext();
  return (
    <>
      <Label aria-label="InvoicingMethodControl" inputSize="medium">
        Invoicing Method
      </Label>
      <CookbookRadioWrapper
        name={name}
        id={`${id}${CorpInvoicingMethod.SINGLE_OPTION}`}
        control={control}
        label="Single Invoice"
        value={CorpInvoicingMethod.SINGLE_OPTION}
      />
      <CookbookRadioWrapper
        name={name}
        id={`${id}${CorpInvoicingMethod.SUBTOTAL_OPTION}`}
        control={control}
        label="Subtotals"
        value={CorpInvoicingMethod.SUBTOTAL_OPTION}
        disabled={singleOptionSelected}
      />
      <CookbookRadioWrapper
        name={name}
        id={`${id}${CorpInvoicingMethod.MULTI_OPTION}`}
        control={control}
        label="Multiple Invoice"
        value={CorpInvoicingMethod.MULTI_OPTION}
        disabled={singleOptionSelected || disabledMultiOption}
      />

      {disabledMultiOption && (
        <Copy variant="caption">{multiDisableReason}</Copy>
      )}
    </>
  );
}
